import React from "react"
import { Globe, Mountain, Flame, Sun, Download } from "lucide-react"
import { downloadReport } from "../../utils/downloadReport"

const REGION_ICONS = {
  globe: Globe,
  asia: Mountain,
  "middle-east": Flame,
  africa: Sun,
}

const ReportCard = ({ report }) => {
  const Icon = REGION_ICONS[report.icon] || Globe

  return (
    <div className="report-card">
      <div
        className="report-card-icon"
        style={{ background: `${report.color}1A`, color: report.color }}
      >
        <Icon size={22} />
      </div>

      <h3 className="report-card-title">{report.title}</h3>
      <p className="report-card-summary">{report.summary}</p>

      <span className="report-card-filesize">PDF &middot; {report.fileSizeLabel}</span>

      <button
        type="button"
        className="report-card-download"
        style={{ "--accent": report.color }}
        onClick={() => downloadReport(report)}
        title={
          report.fileUrl
            ? "Download report"
            : "Report file not uploaded yet — downloads a placeholder"
        }
      >
        Download PDF
        <Download size={15} />
      </button>
    </div>
  )
}

export default ReportCard
